import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <h1>Hi, I'm Ayomide</h1>
      <h2>Frontend Developer</h2>
      <p>I build modern, clean, and responsive web applications.</p>
      <div className="hero-buttons">
        <a href="#contact" className="primary-btn">Get in Touch</a>
        <a href="#projects" className="secondary-btn">View Work</a>
      </div>
    </section>
  );
}
